import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataCatalogTypesActions } from "./catalog-types.actions";

// **************************************************************************
// CATALOG TYPES REDUCER
// **************************************************************************

const load = on(DataCatalogTypesActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        catalogType: {
            ...state.data.catalogType,
            catalogTypesLoading: true,
        },
    },
}));

const loadSuccess = on(DataCatalogTypesActions.loadSuccess, (state: ApplicationStore, { catalogTypes }) => ({
    ...state,
    data: {
        ...state.data,
        catalogType: {
            ...state.data.catalogType,
            catalogTypes,
            catalogTypesLoading: false,
        },
    },
}));

const loadFailure = on(DataCatalogTypesActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        catalogType: {
            ...state.data.catalogType,
            catalogTypesLoading: false,
        },
    },
}));

export const catalogTypesReducer = [load, loadSuccess, loadFailure];
